var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"visible":_vm.visible,"centered":"","hide-footer":"","size":"xl"},on:{"hidden":_vm.hidden}},[_c('b-img',{staticClass:"mx-auto",attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }